import { observer } from 'mobx-react';
import { useCallback, useRef, useState } from 'react';
import { MapLegend } from '../../../../../components/Module/Legend';
import { MapWidgetEventsLegendItem } from '../Events/LegendItem';
import { useMapWidgetStore } from '../MapWidgetContext';
import { MapWidgetNewsLegendItem } from '../News/LegendItem';

export const MapWidgetLegend = observer(() => {
  const { map, baseLayers } = useMapWidgetStore();

  const newsLegendRef = useRef<{ remove(): void }>(null);
  const eventsLegendRef = useRef<{ remove(): void }>(null);

  const [isVisible, setIsVisible] = useState(false);

  const renderCount = useCallback((total: number | undefined) => {
    return total || 0;
  }, []);

  return (
    <MapLegend
      layerCollection={map.layerCollection}
      baseLayers={baseLayers}
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      renderCount={renderCount}
      readonly={true}
      extra={
        <>
          <MapWidgetNewsLegendItem ref={newsLegendRef} />
          <MapWidgetEventsLegendItem ref={eventsLegendRef} />
        </>
      }
    />
  );
});
